import OnsiteCalendarGrid from './OnsiteCalendarGrid.vue'

export default {
  OnsiteCalendarGrid
}



// WEBPACK FOOTER //
// ./src/components/CalendarGrid/index.js